import { useFaqContent } from "./content/faq.js";
import { useFeaturedBoxesContent } from "./content/featuredBoxes.js";
import { useHeroContent } from "./content/hero.js";
import { usePromoCardsContent } from "./content/promoCards.js";
import { useRecentOpensContent } from "./content/recentOpens.js";
import type { HomeContent } from "./contract.js";

/** Every home section's content, the same under every template. */
export function useHomeContent(): HomeContent {
  return {
    hero: useHeroContent(),
    promoCards: usePromoCardsContent(),
    recentOpens: useRecentOpensContent(),
    featuredBoxes: useFeaturedBoxesContent(),
    faq: useFaqContent(),
  };
}
